import styled, { css } from 'styled-components';
import { regularWhite } from './design-tokens';
import { PlayFocus } from './utils.styles';

export const PlayLinkStyles = css`
    color: ${regularWhite};
    text-decoration: ${(props) => (props.underline ? 'underline' : 'none')};
    &:hover,
    &:active,
    &:focus {
        text-decoration: underline;
        cursor: pointer;
    }
`;

export const PlayLinkDiscreet = css`
    ${PlayLinkStyles}
    ${PlayFocus}
    color: inherit;
    text-decoration: none;

    &:hover,
    &:active,
    &:focus {
        text-decoration: underline;
    }
`;

export const PlayLink = styled.a`
    ${PlayLinkStyles}
`;

export const DiscreetLink = styled.a`
    ${PlayLinkDiscreet}
`;
